import { render } from "./SectionInfo.vue?vue&type=template&id=b86857d0&scoped=true&ts=true&lang=pug"
import script from "./SectionInfo.vue?vue&type=script&lang=ts"
export * from "./SectionInfo.vue?vue&type=script&lang=ts"

import "./SectionInfo.vue?vue&type=style&index=0&id=b86857d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86857d0"]])

export default __exports__